export const USER_TYPES = {
  USER: "user",
  CLIENT: "client",
};

export const USER_TYPE_LOGIN = {
  clientes: USER_TYPES.CLIENT,
  agentes: USER_TYPES.USER,
};

export const LOGIN_USER_TYPE = {
  [USER_TYPES.USER]: "agentes",
  [USER_TYPES.CLIENT]: "clientes",
  AGENTES: "agentes",
  CLIENTES: "clientes",
};

export const USER_TYPE_STORAGE_KEY = "USER_TYPE";
